import {withAnalytics} from "../../shared/utility/withAnalytics";

export const postAnalyticsEvents = {
    'more_btn_clicked': withAnalytics('dashboards.business.post.more_btn_clicked'),
    'like_btn_clicked': withAnalytics('dashboards.business.post.like_btn_clicked'),
    'post_comment_btn_clicked': withAnalytics('dashboards.business.post.post_comment_btn_clicked'),
    'show_qr_code_btn_clicked': withAnalytics('dashboards.business.post.show_qr_code_btn_clicked'),
    'copy_link_btn_clicked': withAnalytics('dashboards.business.post.copy_link_btn_clicked'),
}